import React, { useMemo } from 'react';
import { useTranslation } from '@stateManagement/TranslationContext';
import { getTranslation } from '@helpers/languageTranslations';
import { Grid2 } from '@mui/material';
import { breakpoints, space, Text } from '@web-for-marketing/react-ui';
import { RichTextContent } from '@components/RichTextContent';
import { ParseAbbreviations } from '@components/ParseAbbreviations';
import { LightBulbIcon } from '@components/IconComponents/LightBulbIcon';
import { colors } from '@web-for-marketing/react-ui';
import { isMobileAtom } from '@atoms/appSettings';
import { useAtom } from 'jotai';

interface KeyTakeawaysProps {
    content: string;
}

const classes = {
    keyTakeAwayContainer: {
        backgroundColor: colors.background.light,
        padding: '3.2rem 3.2rem',
        borderRadius: '0.4rem',
        [`@media (max-width: ${breakpoints.sm})`]: {
            margin: `0 -${space.containerOuterPadding}`,
            padding: `2.4rem ${space.containerOuterPadding}`,
            borderRadius: '0',
            width: 'unset',
        },
    },
    iconContainer: {
        marginRight: '2.4rem',
    },
};

export const KeyTakeaways = ({ content }: KeyTakeawaysProps): React.ReactElement | null => {
    const { selectedLanguageTranslation } = useTranslation();
    const keyTakeawayTranslation = useMemo(() => {
        return getTranslation(selectedLanguageTranslation, 'blogPost');
    }, [selectedLanguageTranslation]);
    const [isMobile] = useAtom(isMobileAtom);

    return (
        <Grid2 container wrap='nowrap' css={classes.keyTakeAwayContainer}>
            {!isMobile ? (
                <div css={classes.iconContainer}>
                    <LightBulbIcon />
                </div>
            ) : null}
            <div>
                <Text variant='body1' color='primary' weight='bold'>
                    {keyTakeawayTranslation.keyTakeaways}
                </Text>
                <RichTextContent
                    color='primary'
                    content={ParseAbbreviations({
                        content: content,
                        stringFormat: true,
                    })}
                />
            </div>
        </Grid2>
    );
};
